export const termSheetList = ["Term Sheet 1"];
